import { Component } from '@angular/core';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ApiService } from 'app/api.service';
import { Router } from '@angular/router';

@Component({
	selector: 'modal-edit-task-followup',
	templateUrl: './modal-edit-task-followup.component.html'
})
export class ModalEditTaskFollowupComponent extends UIModalBaseComponent {

	title = '';
	note = null;
	disabled = false;
	taskStage = 'active';
	placeholder = '';
	task = null;

	constructor(
		public app: AppService,
		public api: ApiService,
		private router: Router
	) {
		super();
	}

	open(mdata: any) {
		this.note = null;
		this.taskStage = 'active';
		this.task = mdata.task || null;
		if (this.task.stage === 'follow_up') {
			this.placeholder = 'Enter notes regarding the resolution of the follow up';
			this.title = 'Resolve Follow Up';
		} else {
			this.placeholder = 'Enter the notes regarding the follow up';
			this.title = 'Follow Up';
		}
		if (this.task) this.modal.open();
	}

	resolveFollowUp(schedule = false) {
		if (!this.note) {
			this.app.notifications.showDanger('Please enter the notes for resolving the follow up');
			return;
		}
		if (!this.taskStage) {
			this.app.notifications.showDanger('Please select the task stage');
			return;
		}
		this.disabled = true;
		this.api.task.resolveFollowUp({
			id: this.task.id,
			note: this.note,
			stage: this.taskStage
		}, () => {
			this.app.notifications.showSuccess('Task updated.');
			this.disabled = false;
			this.app.navigation.refreshFollowUpTaskCount();
			if (schedule && this.task.work_order_id) this.router.navigate(['/' + this.app.org, 'schedule', 'calendar', this.task.work_order_id]);
			if (schedule) this.modal.close('schedule');
			else this.modal.close('done');
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	markFollowUp() {
		if (!this.note) {
			this.app.notifications.showDanger('Please enter the notes for marking it as follow up');
			return;
		}
		this.disabled = true;
		this.api.task.markAsFollowUp({
			id: this.task.id,
			note: this.note
		}, () => {
			this.app.notifications.showSuccess('Task updated.');
			this.disabled = false;
			this.app.navigation.refreshFollowUpTaskCount();
			this.modal.close();
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

}
